import type { ReactNode } from 'react';

export const symbol_humidity_mid: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-100q-133 0-226.5-91.71T160-415q0-63.14 24.5-120.77Q209-593.4 254-637.5L480-860l226 222.5q45 44.1 69.5 101.73T800-415q0 131.58-93.5 223.29Q613-100 480-100ZM220-415h520q0-51-19.5-97T666-593L480-776 294-593q-35 35-54.5 81.04Q220-465.92 220-415Z"
		/>
	</svg>
);
